import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/icons/close_24.svg'


const _hoisted_1 = {
  key: 0,
  class: "slide-header"
}
const _hoisted_2 = {
  key: 0,
  class: "header-left"
}
const _hoisted_3 = {
  key: 1,
  class: "slide-header"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "top-bar" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "slide-footer",
  ref: "footerRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.visible ? 'bottom-slide-sheet' : 'bottom-slide-sheet-hidden'),
    onWheel: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "slide-back",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBack && _ctx.clickBack(...args)))
    }),
    _createElementVNode("div", {
      class: "slide-frame",
      style: _normalizeStyle(`animation-duration: ${_ctx.duration}s`),
      ref: "frameRef"
    }, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.hideExit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.title)), 1),
            (!_ctx.hideExit)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _imports_0,
                  class: "cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSlide && _ctx.closeSlide(...args)))
                }))
              : _createCommentVNode("", true)
          ]))
        : (!_ctx.title && !_ctx.isMobileDevice())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("img", {
                src: _imports_0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeSlide && _ctx.closeSlide(...args)))
              })
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "slide-header",
              onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveTouch && _ctx.moveTouch(...args))),
              onTouchstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startTouch && _ctx.startTouch(...args))),
              onTouchend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.endTouch && _ctx.endTouch(...args)))
            }, _hoisted_7, 32)),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.maxHeight ? 'slide-content-max' : '', "slide-content"]),
        ref: "contentRef",
        onTouchstart: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.startTouch && _ctx.startTouch(...args))),
        onTouchmove: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.contentMoveTouch && _ctx.contentMoveTouch(...args))),
        onTouchend: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.endTouch && _ctx.endTouch(...args)))
      }, [
        _renderSlot(_ctx.$slots, "content")
      ], 34),
      (_ctx.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "footer")
          ], 512))
        : _createCommentVNode("", true)
    ], 4)
  ], 34))
}